// withAppVisibility.js
import React from "react";
import { useAppVisibility } from "./useAppVisibility";

// HOC that provides: isVisible, isFocused, isOnline, lastChangeAt
export function withAppVisibility(Wrapped) {
  function AppVisibilityWrapper(props) {
    const vis = useAppVisibility();
    return <Wrapped {...props} {...vis} />;
  }

  // Set a helpful display name in React DevTools
  const wrappedName = Wrapped.displayName || Wrapped.name || "Component";
  AppVisibilityWrapper.displayName = `withAppVisibility(${wrappedName})`;

  return AppVisibilityWrapper;
}
